// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.create-ent__country .sk-select__list {\n  max-height: 165px;\n}\n", ""]);
// Exports
module.exports = exports;
